import actions from '../action/recommend'
import CONSTANT from '../constant/recommend'

export default {
  actions,
  state: {
    recommendBanner: [],
    recommendProduct: {
        list: [],
        total: 0
    }
  },
  mutations: {
    [CONSTANT.RECOMMEND_GET_HOT_BANNER_SUCCESS] (state, data) {
      state.recommendBanner = data
    },
    [CONSTANT.RECOMMEND_GET_HOT_BANNER_EMPTY] (state, data) {
        state.recommendBanner = []
    },
    [CONSTANT.RECOMMEND_GET_HOT_BANNER_ERROR] (state, e) {
      state.recommendBanner = []
    },

    

    [CONSTANT.RECOMMEND_GET_HOT_PRODUCT_SUCCESS] (state, data) {
      state.recommendProduct = {list: data.list, total: data.page.total}
    },
    [CONSTANT.RECOMMEND_GET_HOT_PRODUCT_EMPTY] (state, data) {
      state.recommendProduct = {list: [],total: 0}
    },
    [CONSTANT.RECOMMEND_GET_HOT_PRODUCT_ERROR] (state, e) {
      state.recommendProduct = {list: [],total: 0}
    },
    [CONSTANT.RECOMMEND_GET_HOT_PRODUCT_MORE_SUCCESS] (state, result) {
        state.recommendProduct = { total: result.page.total, list: [...state.recommendProduct.list, ...result.list]}
    },
  },
  getters: {
  }
}
